<template>
  <div>
    <div v-for="(file, i) in files" :key="i">
      <vs-divider color="danger" class="my-6 f-14 f-bold">
        {{ file }}
      </vs-divider>

      <div class="vx-row text-center" v-if="data[i].length === 0">
        <div class="vx-col w-full">
          <div>
            <vs-avatar color="success" icon="check" class="custom-icon" />
            <span class="f-12">OK</span>
          </div>
        </div>
      </div>

      <div v-else>
        <vs-row vs-align="center"
    vs-type="flex" vs-justify="center" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-xs="12"
            vs-md="2"
            vs-lg="2"
          >
            <vs-button
              @click="$emit('refresh')"
              color="primary"
              type="filled"
              icon="refresh"
              class="w-full"
            >
              {{ $t('refresh') }}
            </vs-button>
          </vs-col>
        </vs-row>
        <div class="vx-row text-center validations-list">
          <div class="vx-col w-full" v-for="(error, i) in data[i]" :key="i">
            <div class="div-validation-list">
              <vs-avatar color="danger" icon="close" class="custom-icon icon-validation-list" />
              <span class="f-12 text-validation-list">{{ error }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    files: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
.custom-icon {
  width: 16px;
  height: 16px;
  top: 20%;
  .material-icons {
    font-size: 14px;
  }
}


.div-validation-list {
  display: inline-block;
  padding: 5px
}

.text-validation-list{
  clear: left;
  text-align: right;
  vertical-align: middle;
  line-height:25px;
}

.icon-validation-list
{
  display:inline-block;
  vertical-align:top;
}
</style>
